<template>
  <div :class="[$style.Container]">
    <div :class="$style.Header">
      <img
        style="width: 31px; height: 19.7px; margin-left: 16px"
        src="https://static.lingvisions.com/public/a8d66af63e954f4a9185920943edd75a.svg"
      />
      <a :class="$style.Question" target="_blank" href="https://www.lingvisions.com/cases/20">
        常见问题
      </a>
    </div>
    <div :class="$style.Title">{{ list.title }}</div>
    <div :class="$style.Info">
      <div
        v-for="(item, index) in list.storageInfos"
        :class="animated ? undefined : $style.InfoItemAnimation"
        :style="
          animated
            ? undefined
            : {
                animationDelay: `${index * 200}ms`,
              }
        "
        :key="index"
      >
        <img
          style="width: 16px; height: 16px; margin: 4px 4px 0 0"
          src="https://static.lingvisions.com/public/497d18b491de4e5b9e62aac94da233f0.svg"
        />
        <div :class="$style.Tip">{{ item.title }}</div>
      </div>
    </div>
    <div :class="$style.Footer">
      <div :class="$style.Tips">
        <img
          style="margin-right: 4px; margin-top: 1px"
          src="https://static.lingvisions.com/public/01d5bde817be400c882a7d6db73d4860.svg"
        />
        注：若存储空间用满或失效，部分相关操作功能将受限。
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import { computed, ref, watch } from 'vue';

  const list = computed(() => ({
    title: '存储扩容',
    storageInfos: [
      {
        title: '采集、印花、视频、套图、上传图片等操作均会占用存储空间',
      },
      {
        title: '存储扩容独立于灵豆套餐，支持自定义容量及时长',
      },
      {
        title: '团队内成员共享空间容量，不支持转让或拆分',
      },
      {
        title: '存储用满后相关功能将受限，需及时扩容或清理',
      },
    ],
  }));

  const animated = ref(false);
</script>

<style lang="less" module>
  .Container {
    width: 312px;
    position: relative;
    padding: 24px 16px 0;
    background: url(https://static.lingvisions.com/public/f2d54339391e4d328c86c45a4fc7e909.png)
      center/cover no-repeat rgba(219, 109, 6, 1);
    border-radius: 16px 0 0 16px;
  }

  .Title {
    margin-top: 64px;
    font-weight: 600;
    font-size: 20px;
    line-height: 24px;
    letter-spacing: 0%;
    color: rgba(255, 255, 255, 1);
    margin-left: 16px;
  }

  .Header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    height: 22px;
  }

  .Item {
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 16px;
    background-color: rgba(255, 255, 255, 0.1);
    margin-top: 34px;
    padding: 8px 0 8px 16px;
    color: rgba(255, 255, 255, 1);

    > div {
      display: flex;
      align-items: center;
      margin-bottom: 8px;

      &:last-of-type {
        margin-bottom: 0;
      }
    }
  }

  .ItemText {
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
  }

  .Info {
    margin-top: 34px;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: rgba(255, 255, 255, 1);

    > div {
      display: flex;
      align-items: flex-start;
      margin-bottom: 8px;
      margin-left: 16px;

      &:last-of-type {
        margin-bottom: 0;
      }
    }
  }

  .InfoItemAnimation {
    animation: fade-in 0.5s ease forwards;
    opacity: 0;
    transform: translateX(-10px);
  }

  .Footer {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    position: absolute;
    bottom: 24px;
    left: 0;
  }

  .Tips {
    display: flex;
    align-items: flex-start;
    padding: 8px;
    height: 50px;
    background-color: rgba(0, 0, 0, 0.2);
    border-radius: 8px;
    position: absolute;
    left: 16px;
    bottom: 0;
    right: 16px;
    font-family: PingFang SC;
    font-weight: 400;
    font-style: Regular;
    font-size: 12px;
    leading-trim: NONE;
    line-height: 18px;
    letter-spacing: 0%;
    vertical-align: middle;
    color: rgba(255, 255, 255, 1);
  }

  .Message {
    color: rgba(255, 255, 255, 0.5);
    font-size: 12px;
  }

  .Question {
    font-weight: 500;
    font-size: 12px;
    line-height: 1;
    letter-spacing: 0%;
    cursor: pointer;
    color: rgba(255, 255, 255, 1) !important;

    &:hover {
      color: #d16c44 !important;
    }
  }

  @keyframes fade-in {
    from {
      opacity: 0;
      transform: translateX(-10px);
    }

    to {
      opacity: 1;
      transform: translateX(0);
    }
  }

  .MobileContainer {
    padding: 24px;
    background: url(https://static.lingvisions.com/public/75ed34b352734637a71336c8d1d31261.png)
      center/cover no-repeat #225849;

    .Header {
      display: none;
    }

    .Title {
      font-family: PingFang SC;
      font-weight: 600;
      font-style: Semibold;
      font-size: 16px;
      leading-trim: NONE;
      line-height: 16px;
      letter-spacing: 0%;
      vertical-align: middle;
      margin-top: 0;
      margin-left: 0;
    }

    .Item {
      margin-top: 24px;
    }

    .ItemText {
      font-family: PingFang SC;
      font-weight: 400;
      font-style: Regular;
      font-size: 12px;
      leading-trim: NONE;
      line-height: 20px;
      letter-spacing: 0%;
      vertical-align: middle;
    }

    .Info {
      margin-top: 12px;
      font-family: PingFang SC;
      font-weight: 400;
      font-style: Regular;
      font-size: 12px;
      leading-trim: NONE;
      line-height: 20px;
      letter-spacing: 0%;
      vertical-align: middle;
    }
  }
</style>
